import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { httpAdapter } from './adapters/http.ts';
import { SessionGate } from './Session.tsx';
import './styles/tokens.css';
import './styles/app.css';

// F4: la aplicación se alimenta de la frontera de servidor (ADR-010). Nunca habla
// con Supabase: sólo con /api/*, y siempre detrás de una sesión verificada.
//
// `mockAdapter` sigue existiendo como doble de prueba y modo demostración —
// lo usan los tests y no debe borrarse.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionGate>
      {(sesion, salir) => <App port={httpAdapter} sesion={sesion} onSalir={salir} />}
    </SessionGate>
  </StrictMode>,
);
